<script setup lang="ts">
import type { UserResponse } from '@@/types/api';

withDefaults(
  defineProps<{
    user: UserResponse;
    size?: number;
    imageSize?: 64 | 128 | 256;
  }>(),
  {
    size: 32,
    imageSize: 64,
  },
);

const imageError = ref(false);
</script>

<template>
  <v-avatar
    :color="user.has_profile_photo && !imageError ? undefined : 'primary'"
    :size="size"
  >
    <v-img
      v-if="user.has_profile_photo && !imageError"
      :src="userAvatarUrl(user, imageSize)"
      cover
      @error="imageError = true"
    />
    <span
      v-else
      class="text-white"
      :style="{ fontSize: `${size * 0.45}px`, fontWeight: 500 }"
    >
      {{ userInitials(user) }}
    </span>
  </v-avatar>
</template>
